import { gql } from "@apollo/client";

const CHECK_PAY = gql`
  mutation checkPay($input: CheckPayInput!) {
    checkPay(input: $input) {
      __typename
      ... on CheckPay {
        status
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const GET_STATUS_PAY = gql`
  mutation getStatusPay($input: GetStatusPay!) {
    getStatusPay(input: $input) {
      __typename
      ... on Sale {
        id
        sale_status
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { CHECK_PAY, GET_STATUS_PAY };
